import React from "react";
import { useField } from "react-final-form";
import { GivenNameField } from "../../shared/fields";

const CoppaSsoUpdateUserFormFields = () => {
  useField("isCoppa", {
    defaultValue: true
  });
  return (
    <>
      <GivenNameField isRequired={false} />
    </>
  );
};

export default CoppaSsoUpdateUserFormFields;
